/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WidgetCaseListFilters } from './WidgetCaseListFilters';
import {
    WidgetCaseListFiltersFromJSON,
    WidgetCaseListFiltersFromJSONTyped,
    WidgetCaseListFiltersToJSON,
    WidgetCaseListFiltersToJSONTyped,
} from './WidgetCaseListFilters';

/**
 * 
 * @export
 * @interface WidgetOptions
 */
export interface WidgetOptions {
    /**
     * 
     * @type {WidgetCaseListFilters}
     * @memberof WidgetOptions
     */
    caseListFilters?: WidgetCaseListFilters;
}

/**
 * Check if a given object implements the WidgetOptions interface.
 */
export function instanceOfWidgetOptions(value: object): value is WidgetOptions {
    return true;
}

export function WidgetOptionsFromJSON(json: any): WidgetOptions {
    return WidgetOptionsFromJSONTyped(json, false);
}

export function WidgetOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'caseListFilters': json['caseListFilters'] == null ? undefined : WidgetCaseListFiltersFromJSON(json['caseListFilters']),
    };
}

export function WidgetOptionsToJSON(json: any): WidgetOptions {
    return WidgetOptionsToJSONTyped(json, false);
}

export function WidgetOptionsToJSONTyped(value?: WidgetOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'caseListFilters': WidgetCaseListFiltersToJSON(value['caseListFilters']),
    };
}

